import { 
  CARRIER_NAMES, 
  STATUS_DISPLAY_NAMES, 
  MILESTONE_DISPLAY_NAMES,
  ROLE_DISPLAY_NAMES 
} from './constants';

// Date formatting
export const formatDateTime = (dateString) => {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  return date.toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

export const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};

export const formatTime = (dateString) => {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  return date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit'
  });
};

// Display name getters
export const getCarrierDisplayName = (carrierCode) => {
  return CARRIER_NAMES[carrierCode] || carrierCode;
};

export const getStatusDisplayName = (statusCode) => {
  return STATUS_DISPLAY_NAMES[statusCode] || statusCode;
};

export const getMilestoneDisplayName = (milestoneCode) => {
  return MILESTONE_DISPLAY_NAMES[milestoneCode] || milestoneCode;
};

export const getRoleDisplayName = (roleCode) => {
  return ROLE_DISPLAY_NAMES[roleCode] || roleCode;
};

// Status color helpers
export const getStatusColor = (status) => {
  const colors = {
    'BOOKED': 'blue',
    'GATED_IN': 'green', 
    'LOADED': 'orange',
    'IN_TRANSIT': 'purple',
    'DISCHARGED': 'teal',
    'READY_FOR_PICKUP': 'green',
    'DELIVERED': 'gray'
  };
  return colors[status] || 'gray';
};

// Validation helpers
export const isValidContainerNumber = (number) => {
  // Basic container number validation (4 letters + 7 numbers)
  const pattern = /^[A-Z]{4}\d{7}$/;
  return pattern.test(number);
};

export const isValidBookingNumber = (number) => {
  // Booking numbers can vary, basic length check
  return number && number.length >= 6 && number.length <= 20;
};

// Local storage helpers
export const clearStoredAuth = () => {
  sessionStorage.removeItem('agentToken');
};

// API error handler
export const handleApiError = (error) => {
  if (error.response?.data?.error) {
    return error.response.data.error;
  }
  if (error.message) {
    return error.message;
  }
  return 'An unexpected error occurred';
};